import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mipsScalePipe'
})
export class MipsScalePipe implements PipeTransform {

  transform(value: any, motiv: boolean, cogn:Boolean, interp:Boolean, validez:Boolean ): unknown {
    let response = [];
    console.log("value", value);
    value.map(
      v=>{
        if (motiv&&v.group=="Metas Motivacionales") response.push(v);
        if (cogn&&v.group=="Modos Cognitivos") response.push(v);
        if (interp&&v.group=="Conductas Interpersonales") response.push(v);
        if (validez&&(v.group == "Escalas de validez" || !v.group)) response.push(v);
      }
    )
    return response;
  }
}
